<template>
  <v-card
    outlined 
    elevation="2"
    height="calc(100vh - 100px)"
    class="overflow-y-auto" 
  > 
    <v-card-title class="sticky-title">
     <!-- selects para filtrar informacion -->
      <v-row>
        <v-col 
          cols="12" 
          sm="3"
        >
          <v-autocomplete
            outlined
            dense
            clearable
            hide-details
            label="Competencia"
            :items="competencias"
            item-value="id"
            item-text="competencia"
            v-model="competencia"
            @change="filtrarDatos"
          >
          </v-autocomplete>
        </v-col>

        <v-col 
          cols="12" 
          sm="3"
        >
          <v-autocomplete
            outlined
            dense
            clearable
            hide-details
            label="Categoria"
            :items="categorias"
            item-value="id"
            item-text="categoria"
            v-model="categoria"
            @change="filtrarDatos"
          >
          </v-autocomplete>
        </v-col>

        <v-col 
          cols="12" 
          sm="3"
        >
          <v-autocomplete
            outlined
            dense
            clearable
            hide-details
            label="Regional"
            :items="regionales"
            item-value="id"
            item-text="regional"
            v-model="regional"
            @change="filtrarDatos"
          >
          </v-autocomplete>
        </v-col>

        <v-col 
          cols="12" 
          sm="3"
        >
          <v-autocomplete
            outlined
            dense
            clearable
            hide-details
            label="Centro de Formación*"
            :items="centrosFormacion"
            item-value="id"
            item-text="centro_formacion"
            v-model="centroFormacion"
            @change="filtrarDatos"
          >
          </v-autocomplete>
        </v-col>
      </v-row>

      <!-- contadores de registros -->
      <v-row>
        <v-col 
          cols="12" 
          sm="3"
        >
          <CounterCard
            color="#FF5722"
            :value="categoriasTotal"
            icon="mdi-folder-multiple"
            label="Categorias"
          />
        </v-col>

        <v-col 
          cols="12" 
          sm="3"
        >
          <CounterCard
            color="#9C27B0"
            :value="cuposTotal"
            icon="mdi-text-box-plus"
            label="Cupos"
          />
        </v-col>

        <v-col 
          cols="12" 
          sm="3"
        >
          <CounterCard
            color="#3F51B5"
            :value="participantesTotal"
            icon="mdi-account-group"
            label="Participantes"
          />
        </v-col>

        <v-col 
          cols="12" 
          sm="3"
        >
          <CounterCard
            color="#4CAF50"
            :value="lideresTotal"
            icon="mdi-account-multiple"
            label="Lideres"
          />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <!-- grafica cupos y participantes por categoria -->
        <v-col cols="12">
          <v-card 
            outlined 
            elevation="2" 
          >
            <v-card-text>
              <BarChart
                :data="cuposParticipantesCategoriaData"
                :options="cuposParticipantesCategoriaOptions"
              >
              </BarChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <!-- grafica cupos por categoria -->
        <v-col cols="6">
          <v-card 
            outlined 
            elevation="2" 
          >
            <v-card-text>
              <PieChart
                :data="cuposCategoriaData"
                :options="cuposCategoriaOptions"
              >
              </PieChart>
            </v-card-text>
          </v-card>
        </v-col>

         <!-- grafica participantes por categoria -->
        <v-col cols="6">
          <v-card 
            outlined 
            elevation="2" 
          >
            <v-card-text>
              <PieChart
                :data="participantesCategoriaData"
                :options="participantesCategoriaOptions"
              >
              </PieChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <v-row>
        <!-- grafica cupos y participantes por regional -->
        <v-col cols="12">
          <v-card 
            outlined 
            elevation="2" 
          >
            <v-card-text>
              <BarChart
                :data="cuposParticipantesRegionalData"
                :options="cuposParticipantesRegionalOptions"
              >
              </BarChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <!-- grafica lideres por categoria -->
        <v-col cols="12">
          <v-card 
            outlined 
            elevation="2" 
          >
            <v-card-text>
              <BarChart
                :data="lideresCategoriaData"
                :options="lideresCategoriaOptions"
              >
              </BarChart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> 
    </v-card-text>
  </v-card>
</template>
  
<script>
import CounterCard from '../../components/admin/CounterCard.vue';
import BarChart from '@/components/admin/BarChart.vue';
import PieChart from '@/components/admin/PieChart.vue';
  
export default {
   data: () => ({
    competencia: null,
    categoria: null,
    regional: null,
    centroFormacion: null,
   }),

  components: {
    CounterCard,
    BarChart,
    PieChart
  },

  mounted() {
    this.$store.dispatch("gestionarCompetencias")
    this.$store.dispatch("gestionarCategorias")
    this.$store.dispatch("crearRegionales")
    this.$store.dispatch("crearCentrosFormacion");
 
    this.$store.dispatch("participantesCategoriaSenasoft", null);
    this.$store.dispatch("cuposCategoriaSenasoft", null)
    this.$store.dispatch("participantesRegionalSenasoft", null);
    this.$store.dispatch("cuposRegionalSenasoft", null)
    this.$store.dispatch("lideresCategoriaSenasoft", null);
  },
  
  computed: {
    competencias() {
      return this.$store.getters.obtenerCompetencias
    },

    categorias() {
      return this.$store.getters.obtenerCategorias
    },

    regionales() {
      return this.$store.getters.obtenerRegionales
    },

    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacionTablero;
    },

    categoriasTotal() {
      const categorias = this.$store.getters.obtenerCuposCategoriaSenasoft.map(cupoCategoria => cupoCategoria.categoria)
      return categorias.length
    },

    cuposTotal() {
      return this.$store.getters.obtenerCuposCategoriaSenasoft.reduce((suma, cupoCategoria) => {
        return suma + cupoCategoria.cupos
      }, 0);
    },

    participantesTotal() {
      return this.$store.getters.obtenerParticipantesCategoriaSenasoft.reduce((suma, participanteCategoria) => {
        return suma + participanteCategoria.participantes
      }, 0);
    },

    lideresTotal() {
      return this.$store.getters.obtenerLideresCategoriaSenasoft.reduce((suma, liderCategoria) => {
        return suma + liderCategoria.lideres
      }, 0);
    },

    cuposParticipantesCategoriaData() {
      const categorias = this.$store.getters.obtenerCuposCategoriaSenasoft.map(cupoCategoria => cupoCategoria.categoria)
      const participantes = this.$store.getters.obtenerParticipantesCategoriaSenasoft.map(participanteCategoria => participanteCategoria.participantes)
      const cupos = this.$store.getters.obtenerCuposCategoriaSenasoft.map(cupoCategoria => cupoCategoria.cupos)

      const chartData = {
        labels: categorias,
        datasets: [
          {
            label: 'Cupos',
            data: cupos,
            backgroundColor: '#E1BEE7',
            borderColor: '#9C27B0',
            borderWidth: 2
          },

          {
            label: 'Participantes',
            data: participantes,
            backgroundColor: '#C5CAE9',
            borderColor: '#3F51B5',
            borderWidth: 2
          }
        ]
      }

      return chartData
    },

    cuposParticipantesCategoriaOptions() {
      const chartOptions = {
        indexAxis: 'y',
        scales: {
          x: {
            grid: {
              display: false
            }
          },
          y: {
            grid: {
              display: false
            },

            ticks: {
              autoSkip: false,
            }
          }
        }
      }

      return chartOptions
    },

    cuposCategoriaData() {
      const categorias = this.$store.getters.obtenerCuposCategoriaSenasoft.map(cupoCategoria => cupoCategoria.categoria)
      const cupos = this.$store.getters.obtenerCuposCategoriaSenasoft.map(cupoCategoria => cupoCategoria.cupos)

      const chartData = {
        labels: categorias,
        datasets: [
          {
            data: this.generarPorcentaje(cupos),
            backgroundColor: this.generarColorRGB(categorias.length),
          },
        ]
      }

      return chartData
    },

    cuposCategoriaOptions() {
      const chartOptions = {
        cutout: "50%",
        hoverOffset: 8,
        plugins: {
          legend: {
            display: false,
          },

          title: {  
            display: true,
            text: '% Cupos'
          },

          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label + ": " + context.parsed + "%";
              },
            },
          },
        }
      }

      return chartOptions
    },

    participantesCategoriaData() {
      const categorias = this.$store.getters.obtenerParticipantesCategoriaSenasoft.map(participanteCategoria => participanteCategoria.categoria)
      const participantes = this.$store.getters.obtenerParticipantesCategoriaSenasoft.map(participanteCategoria => participanteCategoria.participantes)

      const chartData = {
        labels: categorias,
        datasets: [
          {
            data: this.generarPorcentaje(participantes),
            backgroundColor: this.generarColorRGB(categorias.length),
          },
        ]
      }

      return chartData
    },

    participantesCategoriaOptions() {
      const chartOptions = {
        cutout: "50%",
        hoverOffset: 8,
        plugins: {
          legend: {
            display: false,
          },

          title: {  
            display: true,
            text: '% Participantes'
          },

          tooltip: {
            callbacks: {
              label: function (context) {
                return context.label + ": " + context.parsed + "%";
              },
            },
          },
        }
      }

      return chartOptions
    },

    cuposParticipantesRegionalData() {
      const categorias = this.$store.getters.obtenerCuposRegionalSenasoft.map(cupoRegional => cupoRegional.regional)
      const participantes = this.$store.getters.obtenerParticipantesRegionalSenasoft.map(participanteRegional => participanteRegional.participantes)
      const cupos = this.$store.getters.obtenerCuposRegionalSenasoft.map(cupoRegional => cupoRegional.cupos)

      const chartData = {
        labels: categorias,
        datasets: [
          {
            label: 'Cupos',
            data: cupos,
            backgroundColor: '#E1BEE7',
            borderColor: '#9C27B0',
            borderWidth: 2
          },

          {
            label: 'Participantes',
            data: participantes,
            backgroundColor: '#C5CAE9',
            borderColor: '#3F51B5',
            borderWidth: 2
          }
        ]
      }

      return chartData
    },

    cuposParticipantesRegionalOptions() {
      const chartOptions = {
        indexAxis: 'y',
        scales: {
          x: {
            grid: {
              display: false
            }
          },
          y: {
            grid: {
              display: false
            },

            ticks: {
              autoSkip: false,
            }
          }
        }
      }

      return chartOptions
    },

    lideresCategoriaData() {
      const categorias = this.$store.getters.obtenerLideresCategoriaSenasoft.map(liderCategoria => liderCategoria.categoria)
      const lideres = this.$store.getters.obtenerLideresCategoriaSenasoft.map(liderCategoria => liderCategoria.lideres)

      const chartData = {
        labels: categorias,
        datasets: [
          {
            label: 'Lideres',
            data: lideres,
            backgroundColor: '#C8E6C9',
            borderColor: '#4CAF50',
            borderWidth: 2
          }
        ]
      }

      return chartData
    },

    lideresCategoriaOptions() {
      const chartOptions = {
        indexAxis: 'y',
        scales: {
          x: {
            grid: {
              display: false
            }
          },
          y: {
            grid: {
              display: false
            },

            ticks: {
              autoSkip: false,
            }
          }
        }
      }

      return chartOptions
    }
  },

  methods: {
    filtrarDatos() {
      const filtros = {
        competencia: this.competencia,
        categoria: this.categoria,
        regional: this.regional,
        centro_formacion: this.centroFormacion
      }

      this.$store.dispatch("participantesCategoriaSenasoft", filtros)
      this.$store.dispatch("cuposCategoriaSenasoft", filtros)
      this.$store.dispatch("participantesRegionalSenasoft", filtros);
      this.$store.dispatch("cuposRegionalSenasoft", filtros)
      this.$store.dispatch("lideresCategoriaSenasoft", filtros)
    },

    generarColorRGB(cantidad) {
      const coloresAleatorios = [];

      for (let i = 0; i < cantidad; i++) {
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        coloresAleatorios.push(`rgb(${r}, ${g}, ${b})`);
      }
  
      return coloresAleatorios;
    },

    generarPorcentaje(valores) {
      const total = valores.reduce((suma, currentValue) => suma + currentValue, 0);
      const porcentaje = valores.map((valor) => ((valor / total) * 100).toFixed(1))
      return porcentaje;
    }
  }
};
</script>
  
<style scoped>
.sticky-title {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1; 
}
</style>
  